import { render } from "./VehicleLogisticsInfo.vue?vue&type=template&id=42e3d40f&scoped=true&bindings={}"
import script from "./VehicleLogisticsInfo.vue?vue&type=script&lang=ts"
export * from "./VehicleLogisticsInfo.vue?vue&type=script&lang=ts"

import "./VehicleLogisticsInfo.vue?vue&type=style&index=0&id=42e3d40f&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-42e3d40f"

export default script